<ng-template #heading>
    <sirius-heading [text]="resolvedTitle()" textStyleSize="s" [h]="3"></sirius-heading>
</ng-template>

@if (resolvedImage()) {
    <div class="sir-card-media">
        @if (resolvedContentType().toLowerCase() === 'video') {
            <sirius-play-button [hovered]="isHovered()" [focusable]="false"></sirius-play-button>
        }
        <sirius-image-item [image]="resolvedImage()" [autocrop]="true" [imageData]="imageData()"></sirius-image-item>
    </div>
}
<div class="sir-content">
    @if (hasLink() && !showCta()) {
        <a class="card-custom-link-anchor" [siriusLink]="resolvedLink()" (linkSelect)="onClick()">
            <ng-container [ngTemplateOutlet]="heading" />
        </a>
    } @else {
        <ng-container [ngTemplateOutlet]="heading" />
    }
    <sirius-text-html [html]="resolvedTextHtml()" textStyleSize="m"></sirius-text-html>
</div>

@if (showCta()) {
    <div class="card-custom-link">
        <a
            [siriusLink]="resolvedLink()"
            class="card-custom-link-anchor sir-text-style-paragraph-m-bold"
            (linkSelect)="onClick()"
        >
            {{ resolvedLink().title }}<sirius-icon [name]="'arrow_right_small'"></sirius-icon>
        </a>
    </div>
}
